document.addEventListener('DOMContentLoaded', function () {

  var loader = document.getElementById('InfiniteScroll');

  if (!loader) return;

  var productGrid = document.querySelector(
    '[data-section-type="collection-template"] .grid.grid--uniform[role="list"]'
  );

  if (!productGrid) return;

  var nextUrl = loader.getAttribute('data-next-url');
  var loading = false;

  function loadMore() {

    if (loading || !nextUrl) return;

    loading = true;

    var loadingMessage = document.getElementById('InfiniteScrollLoading');

    if (loadingMessage) {
      loadingMessage.style.display = 'block';
    }

    fetch(nextUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newGrid = doc.querySelector(
          '[data-section-type="collection-template"] .grid.grid--uniform[role="list"]'
        );

        var newLoader = doc.getElementById('InfiniteScroll');

        if (!newGrid) {
          nextUrl = null;
          return;
        }

        while (newGrid.children.length) {
          productGrid.appendChild(newGrid.children[0]);
        }

        if (newLoader) {
          nextUrl = newLoader.getAttribute('data-next-url');
        } else {
          nextUrl = null;
        }

        if (!nextUrl) {
          loader.remove();
        }

      })
      .catch(function (error) {
        console.log('Infinite scroll error:', error);
      })
      .finally(function () {

        loading = false;

        if (loadingMessage) {
          loadingMessage.style.display = 'none';
        }

      });
  }

  window.addEventListener('scroll', function () {

    if (!nextUrl || loading) return;

    var distanceFromBottom =
      document.documentElement.scrollHeight -
      (window.innerHeight + window.scrollY);

    if (distanceFromBottom < 800) {
      loadMore();
    }

  });

});
